import Checkbox from './Inputs/Checkbox.vue'
import Radio from './Inputs/Radio.vue'
import FormGroupInput from './Inputs/formGroupInput.vue'
import Switch from './Switch.vue'
import Progress from './Progress.vue'
import DropDown from './Dropdown.vue'
import Table from './Table.vue'
import FadeRenderTransition from './Transitions/FadeRenderTransition.vue'
import Card from './Cards/Card.vue'
import StatsCard from './Cards/StatsCard.vue'
import Breadcrumb from './Breadcrumb/Breadcrumb.vue'
import BreadcrumbItem from './Breadcrumb/BreadcrumbItem.vue'
import Pagination from './Pagination.vue'
import SidebarPlugin from './SidebarPlugin'
import IconEdit from './Icons/IconEdit.vue'
import IconFolder from './Icons/IconFolder.vue'
import IconTrash from './Icons/IconTrash.vue'
import IconCheckMark from './Icons/IconCheckMark.vue'
import IconWarning from './Icons/IconWarning.vue'
import IconBook from './Icons/IconBook.vue'
import IconArrowRight from './Icons/IconArrowRight.vue'
import IconFlag from './Icons/IconFlag.vue'

let components = {
  Checkbox,
  Switch,
  Progress,
  Pagination,
  Radio,
  FormGroupInput,
  Card,
  StatsCard,
  Table,
  DropDown,
  SidebarPlugin,
  FadeRenderTransition,
  Breadcrumb,
  BreadcrumbItem,
  IconEdit,
  IconFolder,
  IconCheckMark,
  IconWarning,
  IconBook,
  IconArrowRight,
  IconFlag
}
export {
  Checkbox,
  Switch,
  Progress,
  Pagination,
  Radio,
  FormGroupInput,
  Card,
  StatsCard,
  Table,
  DropDown,
  SidebarPlugin,
  FadeRenderTransition,
  Breadcrumb,
  BreadcrumbItem,
  IconEdit,
  IconFolder,
  IconTrash,
  IconCheckMark,
  IconWarning,
  IconBook,
  IconArrowRight,
  IconFlag
}

export default components
